<template>
  <div class="bg-gradient-to-b from-[#f6f5f5] via-[#f5f4f4] to-[#f6f5f5]">
    <div class="3xl:max-w-screen-2xl 4xl:max-w-screen-3xl m-auto relative pt-4 pb-16 md:pb-0">
      <div class="flex m-4 -mb-10 md:-mb-4">
        <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}LogoHeader.svg`" alt="Roof Hub Logo" class="h-[30px] md:hidden" />
      </div>
      <RightNavBar />

      <div v-if="hasQueryParam('code')" class="min-h-screen lg:px-32 md:px-32 px-8 py-10">
        <ResetPassword />
      </div>
      <div v-else class="min-h-screen lg:px-32 md:px-32 px-8 py-10">
        <div class="flex justify-between items-center relative">
          <!-- Left Column: Login & Text -->
          <div class="md:w-[40%] md:mb-20">
            <div class="mb-8">
              <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}LogoHeader.svg`" alt="Roof Hub Logo" class="h-[55px] mb-8 hidden md:flex" />
              <p class="title text-center md:text-left" v-html="$t('hero.heading')"></p>
            </div>
            <component :is="showForgot ? ForgotPasswordCard : LoginCard" @show-forgot="showForgot = true"
              @show-login="showForgot = false" />
          </div>

          <!-- Right Column: Carousel -->
          <div class="hidden md:flex text-center w-[50%]">
            <Carousel class="w-full" />
          </div>
        </div>

        <div class="my-10">
          <KeyFeature />
        </div>

        <!-- Integrated Apps Section -->
        <div>
          <IntegratedAppsSection />
        </div>

        <!-- Additional Sections -->
        <div class="my-10">
          <EstimatesToDelivery />
        </div>
        <div class="my-10">
          <Categories :categories="categories" />
        </div>


        <div class="my-10">
          <DownloadMobileApp />
        </div>

        <div class="my-10">
          <RequestBox />
        </div>

      </div>
      <div>
        <Footer> </Footer>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_LANDING_PATH } from "../config/constants.js";
// Components
import LoginCard from './landing/login/Login.vue'
import ForgotPasswordCard from './landing/login/ForgotPassword.vue'
import Carousel from './landing/login/HeroSection.vue'
import Categories from './landing/login/Categories.vue'
import DownloadMobileApp from './landing/login/DownloadMobileApp.vue'
import EstimatesToDelivery from './landing/login/EstimatesToDelivery.vue'
import IntegratedAppsSection from '@/components/IntegratedAppsSection.vue'
import Footer from '@/components/Footer.vue'
import RequestBox from '@/components/RequestBox.vue'
import RightNavBar from '@/views/landing/login/RightNavBar.vue'
import KeyFeature from '@/views/landing/login/KeyFeature.vue'
import ResetPassword from "@/views/landing/login/ResetPassword.vue"
import { getLanguage } from '@/utilities/cookies';
import { useI18n } from "vue-i18n";


// Category Data
const categories = [
  {
    titleKey: "categories.steepSlopeRoofing",
    icon: new URL(`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}SteepSlopeRoofing.svg`, import.meta.url).href,
  },
  {
    titleKey: "categories.lowSlopeRoofing",
    icon: new URL(`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}LowSlopeRoofing.svg`, import.meta.url).href,
  },
  {
    titleKey: "categories.windowsDoors",
    icon: new URL(`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}WindowsDoors.svg`, import.meta.url).href,
  },
  {
    titleKey: "categories.safety",
    icon: new URL(`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}Safety.svg`, import.meta.url).href,
  },
  {
    titleKey: "categories.roofingAccessories",
    icon: new URL(`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}RoofingAccessories.svg`, import.meta.url).href,
  },
  {
    titleKey: "categories.coatingsSealants",
    icon: new URL(`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}CoatingsSealants.svg`, import.meta.url).href,
  },
  {
    titleKey: "categories.siding",
    icon: new URL(`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}Siding.svg`, import.meta.url).href,
  },
  {
    titleKey: "categories.solar",
    icon: new URL(`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}Solar.svg`, import.meta.url).href,
  },
];

const showForgot = ref(false);
const { locale } = useI18n();

locale.value = getLanguage();


// Returns true if the given path matches the current browser location
function isActivePath(path) {
  return window.location.pathname === path;
}

// Returns true if the query parameter exists in the current window location
function hasQueryParam(param) {
  if (typeof window === 'undefined') return false;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has(param);
}
</script>

<style scoped>
.title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #2E2E2E;
  line-height: 1.3;
}

.top-nav {
  background: linear-gradient(180deg, #F8F8F8 29%, rgba(248, 248, 248, 0) 100%);
}
</style>
